<div class="full-grow-no-shrink-no-basis">
    <particle-entity-selector
            [filterId]="filterId"
            [invalidateSubject]="invalidateSubject"
            [filterTemplateId]="filterTemplateId"
            [endpointName]="endpointName"
            [itemType]="itemType"
            (transfer)="validationChangeEmitter($event)"
    >
    </particle-entity-selector>
</div>
